import {useTheme} from 'contexts/ThemeContext';
import React, {forwardRef, useImperativeHandle, useRef} from 'react';
import {Animated} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';
import constants from '../../../constants';
import BlindToSwipe from '../blindToSwipe';
import ReactionView from '../reactionView';

export interface AnimationReactionViewHandle {
  show: () => void;
}

export interface AnimationReactionViewProps {
  onPressReaction: (reaction: string) => void;
  onPressRaiseHand: () => void;
}

const AnimationReactionView = forwardRef<
  AnimationReactionViewHandle,
  AnimationReactionViewProps
>((props: AnimationReactionViewProps, ref) => {
  const viewHeight = 300;
  const valueToClose = 60;

  const theme = useTheme();
  const styles = styleSheet(theme);

  const bottom = useRef(new Animated.Value(-viewHeight));

  useImperativeHandle(ref, () => ({
    show: (): void => {
      Animated.timing(bottom.current, {
        toValue: 0,
        duration: constants.DEFAULT_ANIMATED_DURATION,
        useNativeDriver: false,
      }).start();
    },
  }));

  const onResponderEnd = (value: number) => {
    Animated.timing(bottom.current, {
      toValue: value > valueToClose ? -viewHeight : 0,
      duration: constants.DEFAULT_ANIMATED_DURATION,
      useNativeDriver: false,
    }).start();
  };

  const onResponderMove = (value: number) => {
    bottom.current.setValue(value);
  };

  const SliderView = (
    <BlindToSwipe
      onResponderMove={onResponderMove}
      onResponderEnd={onResponderEnd}
    />
  );

  return (
    <Animated.View style={[styles.container, {bottom: bottom.current}]}>
      {SliderView}
      <ReactionView
        isShown={true}
        onPressRaiseHand={props.onPressRaiseHand}
        onPressReaction={props.onPressReaction}
      />
    </Animated.View>
  );
});

AnimationReactionView.displayName = 'ReactionView';

export default AnimationReactionView;
